import { VCard } from 'vuetify/lib/components/VCard';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCard,{staticClass:"surface darken-1",style:(_vm.CSS_VARS),attrs:{"id":"loading-wrapper","tile":""}},[_vm._m(0),_c('div',{attrs:{"id":"loading-content"}}),(_vm.showLongLoadMessage)?_c('div',{attrs:{"id":"long-load-time-message"}},[_vm._v(" "+_vm._s(_vm.$t('longLoadTimeMessage'))+" ")]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loading-text"}},[_vm._v(_vm._s(_vm.$t('loadingText')))])
}]

export { render, staticRenderFns }